// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"656":"a64bf723","990":"a64bf723"}[chunkId] + ".chunk.css";
};